import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { Router } from './router/Router'
import { action_authFetch } from './store/actions/auth'
import { Loader, PageLoader } from './components/Loader'
import { BrowserRouter } from 'react-router-dom'
import { PopupOnboard } from './hoc/Popup'
import { useTypedSelector } from './hooks/useTypedSelector'

const Application = () => {
    const { main } = useTypedSelector((s) => s)
    return (
        <>
            <BrowserRouter>
                <Router></Router>
            </BrowserRouter>
            <PopupOnboard></PopupOnboard>
            {main.loading && <PageLoader></PageLoader>}
        </>
    )
}

export function App() {
    const [loading, setLoading] = useState(true)
    const dispatch = useDispatch()

    const init = useCallback(async () => {
        await dispatch(action_authFetch())
        setLoading(false)
    }, [dispatch])

    useEffect(() => {
        init()
    }, [init])

    return loading ? <Loader></Loader> : <Application></Application>
}
